var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[(_vm.onlineSearch)?_c('nc-search',{on:{"addProduct":function($event){return _vm.addProduct($event)}}}):_c('offline-search',{on:{"addProduct":function($event){return _vm.addProduct($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }